import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=604ae7b0&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ae7b0",
  null
  
)

component.options.__file = "banner.vue"
export default component.exports